import { render, staticRenderFns } from "./uploadExcel.vue?vue&type=template&id=0be2604a&scoped=true&"
import script from "./uploadExcel.vue?vue&type=script&lang=js&"
export * from "./uploadExcel.vue?vue&type=script&lang=js&"
import style0 from "./uploadExcel.vue?vue&type=style&index=0&id=0be2604a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2604a",
  null
  
)

export default component.exports